import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateSupplierSignupInvitationMutationCgResponse,
  CreateSupplierSignupInvitationMutationVariables,
} from '@common/graphql/schema';

export const CREATE_SUPPLIER_SIGNUP_INVITATION_MUTATION: TypedDocumentNode<
  CreateSupplierSignupInvitationMutationCgResponse,
  CreateSupplierSignupInvitationMutationVariables
> = gql`
  mutation CreateSupplierSignupInvitation(
    $email: String!
    $supplierName: String!
    $comment: String
    $unitIds: [ID!]!
    $tierIds: [ID!]!
    $roleIds: [ID!]!
  ) {
    createSupplierSignupInvitation(
      email: $email
      supplierName: $supplierName
      comment: $comment
      unitIds: $unitIds
      tierIds: $tierIds
      roleIds: $roleIds
    ) {
      invitation {
        id
        email
        createdAt
        expiresAt
        supplier {
          id
          name
        }
      }
    }
  }
`;
